export default __webpack_public_path__ + "static/media/calender_img.9cf6f3ca.svg";